/* GW Pack: infinite scroll for collection & search grids. Progressive enhancement over Dawn pagination.
   v2 (28 Sep 2026): only ever loads a page number higher than the last one loaded, never re-adds a product
   already in the grid, and restarts cleanly when sort/filters redraw the grid (Dawn facets.js). */
(function () {
  if (window.__gwpackInfinite) return;
  window.__gwpackInfinite = true;

  var gen = 0;            // bumps on every (re)start so stale fetches are ignored
  var state = null;

  function pageOf(href) {
    var m = (href || '').match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  // Next page = Dawn's next arrow (class is --prev in Dawn, the names are swapped), else the lowest
  // numbered link above the current page. Never a page at or below the current one.
  function findNext(root, current) {
    var arrow = root.querySelector('.pagination__item--prev[href]');
    if (arrow && pageOf(arrow.getAttribute('href')) > current) return arrow.getAttribute('href');
    var best = null, bestN = Infinity;
    root.querySelectorAll('.pagination__item.link[href]').forEach(function (el) {
      var n = pageOf(el.getAttribute('href'));
      if (n > current && n < bestN) { bestN = n; best = el.getAttribute('href'); }
    });
    return best;
  }

  function keyOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }

  function start() {
    var myGen = ++gen;
    var grid = document.getElementById('product-grid');
    var wrapper = document.querySelector('.pagination-wrapper[data-gwpack-infinite]');
    if (!grid || !wrapper) { state = null; return; }

    var current = pageOf(location.search);
    var url = findNext(document, current);
    var seen = {};
    Array.prototype.forEach.call(grid.children, function (li) { var k = keyOf(li); if (k) seen[k] = 1; });

    wrapper.style.display = 'none';
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'width:100%;height:1px;';
    grid.parentNode.insertBefore(sentinel, wrapper);
    var spinner = document.createElement('div');
    spinner.style.cssText = 'display:none;padding:2.4rem 0;text-align:center;opacity:.55;font-size:1.2rem;letter-spacing:.05em;';
    spinner.textContent = 'Loading more…';
    grid.parentNode.insertBefore(spinner, wrapper);

    state = { gen: myGen, grid: grid, sentinel: sentinel, spinner: spinner, url: url, current: current, seen: seen, loading: false, done: !url };
    if (window.IntersectionObserver) {
      state.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) load(); });
      }, { rootMargin: '800px 0px' });
      state.io.observe(sentinel);
    }
    check();
  }

  function load() {
    var s = state;
    if (!s || s.loading || s.done || !s.url) return;
    s.loading = true;
    s.spinner.style.display = 'block';
    var target = s.url, targetPage = pageOf(target);
    fetch(target, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (!state || state.gen !== s.gen) return;           // grid was redrawn meanwhile, drop this page
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(newGrid.children, function (li) {
            var k = keyOf(li);
            if (k && s.seen[k]) return;
            if (k) s.seen[k] = 1;
            frag.appendChild(li.cloneNode(true));
          });
          s.grid.appendChild(frag);
        }
        s.current = targetPage;
        s.url = findNext(doc, s.current);
        s.done = !s.url;
        s.loading = false;
        s.spinner.style.display = 'none';
        setTimeout(check, 80);
      })
      .catch(function () { s.loading = false; s.spinner.style.display = 'none'; });
  }

  function check() {
    var s = state;
    if (!s || s.done || s.loading) return;
    if (!document.body.contains(s.sentinel)) return;
    var rect = s.sentinel.getBoundingClientRect();
    if (rect.top < (window.innerHeight || document.documentElement.clientHeight) + 800) load();
  }

  function watchRedraws() {
    var box = document.getElementById('ProductGridContainer');
    if (!box || !window.MutationObserver) return;
    new MutationObserver(function () {
      // Sort or filter change: Dawn replaced the grid. Restart from the new page 1 once it's in.
      if (state && document.body.contains(state.grid)) return;
      if (state && state.io) state.io.disconnect();
      state = null;
      if (document.getElementById('product-grid')) start();
    }).observe(box, { childList: true, subtree: true });
  }

  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check, { passive: true });

  function init() { start(); watchRedraws(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
